package top.wcpe.allincore.ui.runtime.render.model

/**
 * 纹理样式模式枚举。
 *
 * NORMAL 边缘 clamp；REPEAT 循环平铺；MIRROR 镜像平铺；TINT 预留（本期不实现）。
 *
 * ADR-0072 决策 1 镜像：真源为 `platform-client-api` 的
 * `top.wcpe.allincore.platform.client.api.render.command.ImageStyleMode`
 * （纯 Java 8 对外 API，按 ADR-0002 不得 KMP 化）。值名与声明序逐一照抄真源，
 * 一致性由 jvmTest 的 RenderModelConsistencyTest 守护。
 */
enum class ImageStyleMode {
    /** 正常纹理采样：超出 [0,1] discard，边缘 clamp 行为 */
    NORMAL,

    /** UV 超出后循环平铺（fract uv） */
    REPEAT,

    /** UV 超出后镜像平铺 */
    MIRROR,

    /** 颜色色调叠加（预留，本期不实现） */
    TINT,
}
